// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + "club-logos" + "." + "03d61c67" + ".chunk.js";
};